import React from "react";
import {Icon, Block, Title} from "../../../components/components";
import ShowItem from "../../../components/ShowItem";
import { useHistory, useParams } from 'react-router';
import {useTranslation} from "react-i18next";
import { Button } from 'react-bootstrap';
import * as Format from "../../../components/Format";
import {useDeleteUserMutation, useGetUserQuery, useLazyGetUserResendConfirmationInstructionsQuery, useLazyGetUserResetPasswordQuery} from "../../../api/userApiSlice";
import useActionConfirmation from "../../../components/useActionConfirmation";

function User(props) {
  const userId = useParams()["userId"];
  const { t } = useTranslation();
  const {data: user = {}, isSuccess} = useGetUserQuery(userId)
  const [deleteUser] = useDeleteUserMutation()
  const [resetPassword] = useLazyGetUserResetPasswordQuery()
  const [resendConfirmationInstructions] = useLazyGetUserResendConfirmationInstructionsQuery()
  const history = useHistory();

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const {Confirmation: DeleteConfirmation, confirmationProps: deleteConfirmationProps, confirm: deleteConfirm} = useActionConfirmation()

  const handleDelete = function() {
    deleteUser(userId).unwrap()
      .then(() => {
        history.push("/users");
      })
  }

  const handleResetPassword = function() {
    resetPassword(userId).unwrap()
      .then(() => {
        history.push(`/users/${userId}`)
      })
  }

  const handleResendConfirmationInstructions = function() {
    resendConfirmationInstructions(userId).unwrap()
      .then(() => {
        history.push(`/users/${userId}`)
      })
  }

  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} onBack={()=>{history.goBack()}}>
        <Button onClick={() => history.push(`/users/${userId}/edit`)}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
        <Button onClick={() => deleteConfirm(handleDelete, user.lastName)}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
        <Button onClick={() => confirm(handleResendConfirmationInstructions, user.lastName)}>
          <Icon icon='branch' text={t("resend_confirmation_instructions")} />
        </Button>
        <Button onClick={() => confirm(handleResetPassword, user.lastName)}>
          <Icon icon='admin' text={t("reset_password")} />
        </Button>
        <Button onClick={() => window.location = user.masqueradeUrl}>
          <Icon icon='mask' text={t("users.impersonate")} />
        </Button>
      </Title>
      <Block>
        <ShowItem label={t("users.firstName")} value={user.firstName} />
        <ShowItem label={t("users.lastName")} value={user.lastName} />
        <ShowItem label={t("users.company")} value={user.company?.name} />
        <ShowItem label={t("users.email")} value={user.email} />
        <ShowItem label={t("users.phoneNumber")} value={user.phoneNumber} />
        <ShowItem label={t("users.createdAt")}>
          <Format.Date date={user.createdAt} />
        </ShowItem>
        <ShowItem label={t("users.lastConnection")}>
          <Format.Date date={user.currentSignInAt} />
        </ShowItem>
        <ShowItem label={t("users.roles")} array value={user.roles}/>
        <ShowItem label={t("users.subscribedToSdkVersionNewsletter")} value={user.subscribedToSdkVersionNewsletter == true ? t('true') : t('false') }/>
      </Block>
      <Confirmation placeholder="Please enter user last name" {...confirmationProps} deletion={false}/>
      <DeleteConfirmation placeholder="Please enter user last name" {...deleteConfirmationProps} deletion={true}/>
    </>
  )
}

export default User
